<template>
    <div :class="['frame-blue', ...getBemModifiers()]">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'FrameBlue',
};
</script>

<style lang="scss">
    .frame-blue {
        font-family: $goodHomeFontFamily;
        display: flex;
        align-self: stretch;
        flex: 1 100%;
        flex-direction: row;
        justify-content: center;
        text-align: center;
        border: 2px solid $color-castoBlue;
        padding: 3px 1px;

        @include font-modifiers;

        &--line-height-normal {
            line-height: 16px;
        }

        &--product-tail {
            height: 60px;
            margin: 0 $spacing-default;
            padding: 4px 5px;
        }
    }

    @media screen and (min-width: $mf-breakpoint-tablet) {
        .frame-blue {
            padding: 4px 5px;

            &--product-tail {
                font-size: 14px;
                max-width: 180px;
                margin: 0 auto 18px auto;
            }
        }
    }
</style>
